import { useState } from 'react';

interface FaqItem {
  question: string;
  answer: string;
}

const faqItems: FaqItem[] = [
  {
    question: '91吃瓜是什么平台？',
    answer: '91吃瓜是一个专注于热点事件视频聚合与在线观看的平台，提供91吃瓜在线观看、高清视频、最新视频资源与视频大全，覆盖娱乐八卦、社会热点、网红动态等丰富内容，支持流畅在线播放。',
  },
  {
    question: '91吃瓜的视频需要付费观看吗？',
    answer: '不需要。91吃瓜所有视频内容均免费在线观看，无需注册或登录即可浏览。我们致力于提供清爽无广告的观看体验，让每一位用户都能自由畅享精彩吃瓜内容。',
  },
  {
    question: '视频更新频率如何？能看最新内容吗？',
    answer: '平台每日更新超过2000条视频，热门事件发生后最快10分钟内即可上线相关视频。91吃瓜最新视频专区实时刷新，确保你不遗漏任何精彩瞬间，随时掌握一手吃瓜动态。',
  },
  {
    question: '91吃瓜支持哪些设备观看？',
    answer: '91吃瓜全面支持桌面浏览器、平板电脑和智能手机访问。同时提供 iOS 与 Android 双平台移动客户端，支持高清流畅播放和离线缓存功能，让你随时随地在线观看91吃瓜视频。',
  },
  {
    question: '如何向91吃瓜投稿或爆料？',
    answer: '欢迎通过投稿邮箱 tougao@91chigua.com 或微信客服 91chiguaVIP 向我们提供独家线索和视频。投稿经审核后最快10分钟上线发布，优质内容将获得首页推荐展示机会。',
  },
];

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="w-full py-16 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 text-center mb-10">常见问题</h2>
        <div className="flex flex-col gap-3">
          {faqItems.map((item, idx) => (
            <div
              key={idx}
              className="bg-background-100 rounded-xl overflow-hidden"
            >
              <button
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer hover:bg-background-200/50 transition-colors duration-200"
                onClick={() => setOpenIndex(openIndex === idx ? null : idx)}
              >
                <h3 className="text-sm md:text-base font-medium text-foreground-800 pr-4">{item.question}</h3>
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                  <i
                    className={`ri-${
                      openIndex === idx ? 'subtract' : 'add'
                    }-line text-lg text-foreground-500 transition-transform duration-200`}
                  ></i>
                </div>
              </button>
              {openIndex === idx && (
                <div className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">
                  {item.answer}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}